<template>
  <!-- 老师详情页 -->
  <div class="TeacherDetailsPage">
    <div class="head">
      <div class="information">
        <div class="imgslsxx">
          <img class="imgls" :src="http + teacher.tx" alt="" />
        </div>
        <div class="lsinformation">
          <h5>{{ teacher.name }}</h5>
          <div class="Thetitle">
            <span v-for="(item, index) in teacher.userzc" :key="index">{{
              item.zcname
            }}</span>
          </div>
          <p class="introduce">
            {{ teacher.iresume }}
          </p>
          <div class="certificate">
            <span v-for="(item, index) in teacher.userzs" :key="index">{{
              item.zsname
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-menu
      :default-active="sckecxx"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item
        :style="{ color: sckecxx == '课程列表' ? ' #4CCAFF' : '#000' }"
        index="课程列表"
        >课程列表</el-menu-item
      >
      <el-menu-item
        :style="{ color: sckecxx == '视频科普' ? ' #4CCAFF' : '#000' }"
        index="视频科普"
        >视频科普</el-menu-item
      >
      <el-menu-item
        :style="{ color: sckecxx == '文章科普' ? ' #4CCAFF' : '#000' }"
        index="文章科普"
        >文章科普</el-menu-item
      >
      <el-menu-item
        :style="{ color: sckecxx == '优质论文' ? ' #4CCAFF' : '#000' }"
        index="优质论文"
        >优质论文</el-menu-item
      >
      <el-menu-item
        :style="{ color: sckecxx == '素材列表' ? ' #4CCAFF' : '#000' }"
        index="素材列表"
        >素材列表</el-menu-item
      >
    </el-menu>

    <div class="pbbu" v-if="sckecxx == '素材列表'">
      <div class="Thehead">
        <h5>素材列表</h5>
        <div class="category">
          <span>专业大类</span>:
          <el-select
            class="sssssda"
            v-model="value"
            placeholder="请选择"
            @change="selmaterialis()"
          >
            <el-option label="全部" value="全部"> </el-option>
            <el-option
              v-for="item in ossptions"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <ul v-if="teplsta.length > 0">
        <!-- '@click="detailspage()" -->
        <li class="Live1" v-for="item in teplsta" :key="item.id">
          <div @click="detailspage(item.id)" class="Figuremove">
            <img
              v-if="item.wjgs == '图片' || item.wjgs == '动图'"
              :src="http + item.scwj"
              alt=""
            />
            <!-- <video   v-if="item.wjgs == '视频' " :src="http+item.scwj" ></video> -->
          </div>
          <div class="Thetitle">
            <div class="Thetitle-top">
              <p @click="detailspage(item.id)">
                {{ item.scmc }}
              </p>
              <span @click="detailspage(item.id)">{{ item.wjgs }}</span>
            </div>
            <div class="Thetitle-center">
              <span class="Thetitle-jg">{{ item.sfff }}</span>
              <span
                style="
                  font-size: 12px;
                  display: flex;
                  color: #999999;
                  line-height: 20px;
                "
              >
                <i class="iconfont gos-yanjing1" style="margin-right: 10px"></i>
                <p class="dzs">浏览量：{{ item.ll }}</p>
              </span>
            </div>
            <div class="Thetitle-bottom">
              <div class="Photoname">
                <!-- <img :src="http + item.tx" alt="" />
                <span>
                  {{ item.name }}
                </span> -->
              </div>
              <el-button @click="detailspage(item.id)">立即查看</el-button>
            </div>
          </div>
        </li>
      </ul>
      <el-empty v-else description="暂无数据"></el-empty>
    </div>
    <div class="box" v-if="sckecxx == '课程列表'">
      <div class="box-keche">
        <div class="Thehead">
          <h5>课程列表</h5>
          <div class="category">
            <span>专业大类</span>:
            <el-select
              class="sssssda"
              v-model="value"
              placeholder="请选择"
              @change="sellsitemis()"
            >
              <el-option label="全部" value="全部"> </el-option>
              <el-option
                v-for="item in ossptions"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <ul class="Course">
          <li class="Live1" v-for="item in teplesname" :key="item.id">
            <video
              class="videceosa"
              @click="umpis(item)"
              :poster="$store.state.https + item.tp"
              :src="http + item.sp"
              alt=""
            ></video>
            <div class="thevideo">
              <!-- <div @click="umpis(item)">{{item.name}}</div> -->
              <div class="th4" @click="umpis(iten)">
                {{ item.name }}
              </div>
              <p class="wb" @click="umpis(item)" v-html="item.kcjs"></p>
              <div class="jejq">
                <span class="je">{{ item.jg }}</span>
                <div>
                  <i
                    style="font-size: 14px; color: #999999; line-height: 20px"
                    class="iconfont gos-yanjing1"
                  ></i>
                  <p class="dzs">浏览量：{{ item.ll }}</p>
                </div>
              </div>
              <div class="collection">
                <span class="dzs"></span>
                <button class="Buynow" @click="umpis(item)">立即播放</button>
              </div>
            </div>
          </li>
        </ul>
        <el-pagination
          v-if="pagethes.total > 0"
          class="ceisj"
          prev-text="上一页"
          next-text="下一页"
          @current-change="handleCurrentChange"
          :page-size="pagethes.rows"
          background
          layout="prev, pager, next"
          :total="pagethes.total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="box" v-if="sckecxx == '视频科普'">
      <div class="box-keche">
        <div class="Thehead">
          <h5>视频列表</h5>
          <div class="category">
            <span>专业大类</span>:
            <el-select
              class="sssssda"
              v-model="value"
              placeholder="请选择"
              @change="selknow()"
            >
              <el-option label="全部" value="全部"> </el-option>
              <el-option
                v-for="item in ossptions"
                :key="item.id"
                :label="item.sort"
                :value="item.sort"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <ul class="Course">
          <li class="Live1" v-for="item in formInline" :key="item.id">
            <video
              class="videceosa"
              @click="umpis(item)"
              :poster="$store.state.https + item.picture"
              :src="http + item.video"
              alt=""
            ></video>
            <div class="thevideo">
              <!-- <div @click="umpis(item)">{{item.name}}</div> -->
              <div class="th4" @click="umpis(iten)">
                {{ item.name }}
              </div>
              <p class="wb" @click="umpis(item)" v-html="item.content"></p>
              <div class="jejq">
                <span class="je" style="visibility: hidden">1</span>
                <div>
                  <i
                    style="font-size: 14px; color: #999999; line-height: 20px"
                    class="iconfont gos-yanjing1"
                  ></i>
                  <p class="dzs">浏览量：{{ item.ll }}</p>
                </div>
              </div>
              <div class="collection">
                <span class="dzs"></span>
                <button class="Buynow" @click="umpis(item)">立即播放</button>
              </div>
            </div>
          </li>
        </ul>
        <el-pagination
          v-if="pagethes.total > 0"
          class="ceisj"
          prev-text="上一页"
          next-text="下一页"
          @current-change="handleCurrentChange"
          :page-size="pagethes.rows"
          background
          layout="prev, pager, next"
          :total="pagethes.total"
        >
        </el-pagination>
      </div>
    </div>

    <div class="box" v-if="sckecxx == '文章科普'">
      <div class="box-keche">
        <div class="Thehead">
          <h5>文章列表</h5>
          <div class="category">
            <span>专业大类</span>:
            <el-select
              class="sssssda"
              v-model="value"
              placeholder="请选择"
              @change="selknow()"
            >
              <el-option label="全部" value="全部"> </el-option>
              <el-option
                v-for="item in ossptions"
                :key="item.id"
                :label="item.sort"
                :value="item.sort"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <ul class="Course1">
          <li
            class="Live1"
            v-for="item in formInline"
            :key="item.id"
            @click="umpis(iten)"
          >
            <!-- <video
              class="videceosa"
              @click="umpis(item)"
              :poster="item.picture"
              :src="http + item.video"
              alt=""
            ></video> -->
            <el-image
              class="img1"
              :src="item.picture"
              style="
                width: 146px;
                height: 82px;
                margin-top: 10px;
                margin-left: 5px;
              "
              alt=""
            />
            <div class="thevideo">
              <!-- <div @click="umpis(item)">{{item.name}}</div> -->
              <div
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  font-size: 15px;
                  width: 220px;
                  text-align: left;
                "
                @click="umpis(iten)"
              >
                {{ item.name }}
              </div>
              <p class="wb" @click="umpis(item)" v-html="item.content"></p>
              <div class="jejq">
                <span class="je" style="visibility: hidden">1</span>
                <div style="text-align: right">
                  <i
                    style="font-size: 14px; color: #999999; line-height: 20px"
                    class="iconfont gos-yanjing1"
                  ></i>
                  <p class="dzs">浏览量：{{ item.ll }}</p>
                </div>
              </div>
              <div class="collection">
                <span class="dzs"></span>
                <!-- <button class="Buynow" @click="umpis(item)">立即播放</button> -->
              </div>
            </div>
          </li>
        </ul>
        <el-pagination
          v-if="pagethes.total > 0"
          class="ceisj"
          prev-text="上一页"
          next-text="下一页"
          @current-change="handleCurrentChange"
          :page-size="pagethes.rows"
          background
          layout="prev, pager, next"
          :total="pagethes.total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="box" style="min-height: 500px" v-if="sckecxx == '优质论文'">
      <div class="buttom1">
        <div class="Thehead">
          <h5>优质论文列表</h5>
          <div class="category">
            <span>专业大类</span>:
            <el-select
              class="sssssda"
              v-model="value"
              placeholder="请选择"
              @change="selknow()"
            >
              <el-option label="全部" value="全部"> </el-option>
              <el-option
                v-for="item in ossptions"
                :key="item.id"
                :label="item.sort"
                :value="item.sort"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <ul class="Course2">
          <li
            class="Live1"
            v-for="(iten, index) in tableData"
            :key="index"
            @click="jump(iten)"
          >
            <video
              v-if="iten.sorts == '视频'"
              :poster="iten.picture ? iten.picture : commonIMG"
              class="videois"
              @click="jump(iten)"
              :src="htto + iten.video"
            ></video>
            <el-image
              v-else
              class="videois"
              :src="iten.picture ? iten.picture : commonIMG"
            />
            <i
              v-if="iten.sorts == '视频'"
              class="el-icon-video-play"
              style="
                font-size: 60px;
                position: absolute;
                margin-left: 100px;
                margin-top: 65px;
                color: #ffffff;
                opacity: 0.5;
              "
            ></i>
            <div class="thevideo">
              <div style="display: flex">
                <div class="thename" @click="jump(iten)">
                  {{ iten.name }}
                </div>
                <i
                  class="el-icon-star-on"
                  style="color: #f86626; font-size: 18px"
                >
                  {{ iten.score }}</i
                >
              </div>
              <p class="wb" @click="jump(iten)" v-html="iten.content"></p>

              <div class="collection">
                <span class="dzs" @click="eacherpage(iten.userid)"
                  ><img class="imgssz" :src="htto + iten.user.tx" alt="" />{{
                    iten.user.name
                  }}</span
                >
                <div class="jejq">
                  <!-- <span class="je">{{ iten.jg }}</span> -->
                  <div>
                    <i
                      style="font-size: 14px; color: #999999; line-height: 20px"
                      class="iconfont gos-yanjing1"
                    ></i>
                    <p class="dzs">浏览量：{{ iten.ll }}</p>
                  </div>
                  <!-- <div v-if="radio4 === '收藏'">
                    <i
                      style="font-size: 14px; color: #999999; line-height: 20px"
                      class="iconfont gos-aixin"
                    ></i>
                    <p class="dzs">收藏：{{ iten.sc }}</p>
                  </div>
                  <div v-if="radio4 === '最新' || radio4 === '最新倒'">
                    <p class="dzs">{{ iten.scrq }}</p>
                  </div>
                  <div v-if="radio4 === '点赞'">
                    <p class="dzs">点赞量：{{ iten.dz }}</p>
                  </div>
                  <div v-if="radio4 === '评分'">
                    <el-rate disabled v-model.number="iten.pf"></el-rate>
                  </div> -->
                </div>
                <!-- <button
                    v-if="iten.jg !== '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即购买
                  </button>
                  <button
                    v-if="iten.jg == '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即查看
                  </button> -->
              </div>
            </div>
          </li>
        </ul>
        <el-pagination
          v-if="this.paging.total !== 0"
          @current-change="handleCurrentChange"
          :page-size="paging.rows"
          background
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next"
          :total="paging.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  sellsitem,
  seluser,
  selsort,
  selusersc,
  selknow,
  selsortMu,
} from "../api/patient";
export default {
  data() {
    return {
      value: "全部",
      http: this.$store.state.https,
      ossptions: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      teacher: "",
      teplesname: [],
      formInline: [],
      pagethes: {
        page: 1,
        rows: 12,
        total: 50,
      },
      sckecxx: "课程列表",
      teplsta: {},
      tableData: [],
      paging: {
        page: 1,
        rows: 10,
        total: 50,
      },
    };
  },
  created() {
    this.sellsitemis();
    this.seluseris();
    this.selsortis();
  },
  methods: {
    // 课程列表
    async selitemis(item) {
      var data = new FormData();
      data.append("page", this.paging.page);
      data.append("rows", this.paging.rows);
      data.append("status", "已通过");
      data.append("score", 4.5);
      data.append("phone", this.teacher.phone);
      let res = await selknow(data);
      this.tableData = res.records;
      this.paging.total = res.totalCount;
      console.log(res.records);
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].sorts == "视频") {
          this.tableData[i].picture = this.htto + this.tableData[i].picture;
        }
        // this.tableData[i].pf = Number(this.tableData[i].pf);
      }

      // this.radio4 = '默认'
    },
    // 素材详情
    detailspage(item) {
      this.$router.push("/materialdetailspage");
      this.$store.commit("sucaixingqi", item);
    },
    // 导航栏切换
    handleSelect(val) {
      // this.$store.commit("collection", val);
      this.sckecxx = val;
      this.pagethes.page = 1;
      this.pagethesrows = 12;
      if (val == "课程列表") {
        this.sellsitemis();
        this.selsortis();
      }
      if (val == "素材列表") {
        this.selmaterialis();
        this.selsortis();
      }
      if (val == "视频科普") {
        this.selknow();
        this.selsortMu();
      }
      if (val == "文章科普") {
        this.selknow();
        this.selsortMu();
      }
      if (val == "优质论文") {
        // this.selsortMu();
        this.selitemis();
      }
    },
    selknow() {
      var data = new FormData();
      data.append("page", this.pagethes.page);
      data.append("rows", this.pagethes.rows);
      if (this.value !== "全部") {
        data.append("sort", this.value);
      }
      if (this.sckecxx == "视频科普") {
        data.append("sorts", "视频");
      } else {
        data.append("sorts", "文章");
      }
      data.append("phone", this.teacher.phone);
      data.append("status", "已通过");
      selknow(data).then((res) => {
        console.log(res);
        this.formInline = res.records;
        this.pagethes.total = res.totalCount;
        // for (let i = 0; i < this.formInline.length; i++) {
        //   var a = this.formInline[i].statustime.split(" ");
        //   this.formInline[i].statustime = a[0];
        // }
      });
    },
    selsortis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      selsort(data).then((res) => {
        this.ossptions = res.rows;
      });
    },
    selsortMu() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      data.append("name", "知识科普");
      selsortMu(data).then((res) => {
        this.ossptions = res;
      });
    },
    //   老师信息
    seluseris() {
      var data = new FormData();
      data.append("id", this.$route.params.id);
      seluser(data).then((res) => {
        this.teacher = res;
      });
    },
    // /跳转
    jump(item) {
      this.$store.commit("Jumpfordetails", item.id);
      if (item.sorts == "视频") {
        this.$router.push("/PopularScienceDetails");
      } else {
        this.$router.push("/ArticleDetails");
      }
      window.scrollTo({
        top: 1,
      });
    },
    //   跳转课程详情
    umpis(item) {
      if (this.sckecxx == "视频科普") {
        this.$router.push("/PopularScienceDetails");
      }
      if (this.sckecxx == "文章科普") {
        this.$router.push("/ArticleDetails");
      }

      if (this.sckecxx == "课程列表") {
        this.$router.push("/coursedetailspage");
      }
      this.$store.commit("Jumpfordetails", item.id);
    },
    // 获取课程列表
    async sellsitemis() {
      var data = new FormData();
      data.append("id", this.$route.params.id);
      data.append("page", this.pagethes.page);
      data.append("rows", this.pagethes.rows);
      if (this.value !== "全部") {
        data.append("sort", this.value);
      }
      await sellsitem(data).then((res) => {
        this.teplesname = res.rows;
        this.pagethes.total = res.total;
      });
    },
    // 素才列表
    async selmaterialis() {
      var data = new FormData();
      data.append("id", this.$route.params.id);
      data.append("page", this.pagethes.page);
      data.append("rows", this.pagethes.rows);
      data.append("status", "已通过");
      if (this.value !== "全部") {
        data.append("sort", this.value);
      }

      await selusersc(data).then((res) => {
        this.teplsta = res.rows;
        this.pagethes.total = res.total;
        for (let s = 0; s < this.teplsta.length; s++) {
          var a = this.teplsta[s].statustime.split(" ");
          this.teplsta[s].statustime = a[0];
          this.teplsta[s].pf = Number(this.teplsta[s].pf);
        }
      });
    },
    handleSelsssect(key, keyPath) {},
    handleCurrentChange(val) {
      this.pagethes.page = val;
      this.sellsitemis();
    },
  },
};
</script>
<style lang="scss">
.el-tabs__item {
  font-size: 18px;
}
</style>
<style lang="scss" scoped>
.TeacherDetailsPage {
  width: 100%;
}
.el-menu-demo {
  // text-align: center;
  padding: 0;
  padding-top: 18px;
  height: 54px;
  padding-left: 20vw;
  // margin: auto;
  // width: 40px;
  line-height: 54px;
  border: 0px;
  display: flex;

  .el-menu-item {
    margin-left: 120px;
    padding: 0 5px;
    height: 40px;
    line-height: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    // color: #4CCAFF;
  }
  ::v-deep.is-active {
    border-bottom: 2px solid #4ccaff;
  }
}
.pbbu {
  width: 1090px;
  margin: 0 auto;
  margin-top: 35px;
  min-height: 720px;
  text-align: left;
  .Thehead {
    margin-top: 35px;
    display: flex;
    h5 {
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .category {
      span {
        margin-left: 750px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    li {
      width: 247px;
      height: 265px;
      background: #ffffff;
      border: 1px solid #f6f6f6;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.22);
      border-radius: 6px;
      margin-bottom: 20px;
      margin-right: 20px;
      transition: all 0.2s;
      .Thetitle {
        // display: flex;
        padding: 9px 20px 0px 20px;
        // margin-top: 10px;
        // justify-content: space-between;
        // width: 213px;
        .Thetitle-top {
          display: flex;
          justify-content: space-between;
          p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            width: 150px;
            height: 18px;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 1; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
          }
          span {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
  }
}
.Live1:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
}
.Figuremove {
  width: 247px;
  height: 151px;
  // background: #409EFF;
  border-radius: 6px 6px 0px 0px;
  img {
    // position:absolute;
    width: 100%;
    height: 100%;
  }
  video {
    width: 100%;
    height: 100%;
  }
}
.Thetitle-center {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  .Thetitle-jg {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ff1616;
  }
  .xinx {
    width: 12px;
    height: 11px;
    color: #999999;
    margin-right: 5px;
  }
}
.Thetitle-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 11px;
  border-top: 1px solid #f6f6f6;
  padding: 10px 0;
  .el-button--default {
    padding: 0px;
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    width: 67px;
    height: 23px;
    background: #4ccaff;
    border-radius: 4px;
  }
  .el-button:active {
    border-color: #4ccaff;
  }
}
.Photoname {
  display: flex;
  img {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-right: 8px;
  }

  span {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    width: 110px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
}
.box {
  width: 1090px;
  margin: 0 auto;
}
.head {
  width: 100%;
  height: 402px;
  background: url("../assets/backgroundLecturer.png") repeat;
  background-size: 100% 100%;
  .information {
    width: 1090px;
    margin: 0 auto;
    height: 100%;
    // background: red;
    display: flex;
    .imgslsxx {
      width: 235px;
      height: 402px;
      //   background: #fff;
      margin-left: 170px;
      margin-right: 23px;
      .imgls {
        height: 360px;
        margin-top: 42px;
        width: 210px;
        text-align: left;
      }
    }
  }
}
.lsinformation {
  display: flex;
  text-align: left;
  flex-direction: column;
  h5 {
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    margin-top: 70px;
    margin-bottom: 5px;
  }
  .Thetitle {
    span {
      margin-right: 10px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .introduce {
    width: 509px;
    margin-top: 11px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
  }
  .certificate {
    margin-top: 20px;
    span {
      padding: 5px 10px;
      border: 1px solid #ffffff;
      border-radius: 15px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      // line-height: 23px;
    }
  }
}
.box-keche {
  text-align: left;
  .Thehead {
    margin-top: 35px;
    display: flex;
    h5 {
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .category {
      span {
        margin-left: 750px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }
    }
  }
}
.sssssda ::v-deep .el-input--suffix .el-input__inner {
  width: 150px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 16px;
}
.sssssda
  ::v-deep
  .el-input--suffix
  .el-input__suffix
  .el-input__suffix-inner
  .el-select__caret {
  line-height: 32px;
}
.Course1 {
  margin-top: 20px;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 21px;
  .Live1 {
    margin-right: 15px;
    width: 511px;
    height: 100px;
    background: #ffffff;
    border: 1px solid #f6f6f6;
    border-radius: 6px;
    margin-bottom: 20px;
    transition: all 0.2s;
    display: flex;
    .thevideo {
      // display: flex;
      // flex-direction: column;
      padding: 10px 20px;
      .th4 {
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 15px;
        width: 220px;
        text-align: left;
      }
      .wb {
        display: flex;
        text-align: left;
        margin-top: 12px;
        width: 337px;
        height: 34px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 2; /**显示的行数**/
        overflow: hidden; /**隐藏超出的内容**/
      }
      .jejq {
        // margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .je {
          width: 66px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ff1616;
        }
        div {
          display: flex;
          img {
            width: 12px;
            height: 12px;
            line-height: 12px;
            margin-right: 8px;
            padding-top: 2px;
          }
          .dzs {
            margin-left: 5px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
          }
        }
      }
      .collection {
        margin-top: 13px;
        display: flex;
        justify-content: space-between;
        .dzs {
          white-space: nowrap;
          height: 13px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
        }
        .Buynow {
          white-space: nowrap;
          // display: flex;
          text-align: center;
          width: 67px;
          height: 23px;
          background: #4ccaff;
          border-radius: 4px;
          border: 1px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
  .Live1:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }
}
.Course {
  margin-top: 20px;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 21px;
  .Live1 {
    margin-right: 15px;
    width: 247px;
    height: 299px;
    background: #ffffff;
    border: 1px solid #f6f6f6;
    border-radius: 6px;
    margin-bottom: 20px;
    transition: all 0.2s;
    .thevideo {
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      .th4 {
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 15px;
        width: 220px;
        text-align: left;
      }
      .wb {
        display: flex;
        text-align: left;
        margin-top: 12px;
        width: 203px;
        height: 34px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 2; /**显示的行数**/
        overflow: hidden; /**隐藏超出的内容**/
      }
      .jejq {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .je {
          width: 66px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ff1616;
        }
        div {
          display: flex;
          img {
            width: 12px;
            height: 12px;
            line-height: 12px;
            margin-right: 8px;
            padding-top: 2px;
          }
          .dzs {
            margin-left: 5px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
          }
        }
      }
      .collection {
        margin-top: 13px;
        display: flex;
        justify-content: space-between;
        .dzs {
          white-space: nowrap;
          height: 13px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
        }
        .Buynow {
          white-space: nowrap;
          // display: flex;
          text-align: center;
          width: 67px;
          height: 23px;
          background: #4ccaff;
          border-radius: 4px;
          border: 1px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
  .Live1:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }
}
.ceisj {
  text-align: center;
  margin-bottom: 54px;
}
.videceosa {
  width: 247px;
  height: 139px;
  border-radius: 6px 6px 0px 0px;
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}
img {
  object-fit: cover;
}
.buttom1 {
  margin-top: 27px;
  .Thehead {
    margin-top: 35px;
    display: flex;
    h5 {
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .category {
      span {
        margin-left: 750px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  .Course2 {
    display: flex;
    width: 1140px;
    justify-content: left;
    flex-wrap: wrap;
    margin-top: 20px;
    .Live1 {
      display: flex;
      width: 520px;
      height: 110px;
      background: #ffffff;
      border: 1px solid #f6f6f6;
      border-radius: 6px;
      margin-bottom: 17px;
      transition: all 0.2s;
      margin-left: 17px;
      .videois {
        width: 200.6px;
        height: 87.6px;
        padding: 12px 6px 10px 10px;
        border-radius: 6px 6px 0px 0px;
        // object-fit: contain;
      }
      .thevideo {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 10px 6px;
        .thename {
          font-size: 15px;
          width: 300px;
          text-align: left;
          font-weight: bold;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .wb {
          display: block !important;
          margin-top: 0px !important;
          text-align: left;
          cursor: pointer;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 2; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
          font-size: 12px;
          line-height: 22px;
        }

        .collection {
          // padding-top: 6px;
          // margin-top: 5px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-top: 2px solid #f6f6f6;
          .jejq {
            margin-right: 5px;
            display: flex;
            justify-content: space-between;
            .je {
              // width: 66px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ff1616;
            }
            div {
              display: flex;
              align-items: center;
              img {
                width: 12px;
                height: 12px;
                line-height: 12px;
                margin-right: 8px;
                padding-top: 2px;
              }
              .dzs {
                font-size: 12px;
                margin-left: 5px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
              }
            }
          }
          .dzs {
            cursor: pointer;
            white-space: nowrap;
            // height: 13px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999;
          }
          .Buynow {
            cursor: pointer;
            white-space: nowrap;
            // display: flex;
            text-align: center;
            width: 67px;
            height: 23px;
            background: #4ccaff;
            border-radius: 4px;
            border: 1px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
          .Buynow:hover {
            background: #4ccaffc9;
          }
        }
      }
    }
    .Live1:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
    }
  }
  .el-pagination {
    margin-top: 60px;
    margin-bottom: 30px;
  }
}

// 适配手机端
@media (max-width: 768px) {
  .TeacherDetailsPage {
    width: 100%;
  }
  .el-menu-demo {
    padding-left: 0vw;
    .el-menu-item {
      margin-left: 10px;
      font-size: 14px;
    }
  }
  .pbbu {
    width: 100vw;
    .Thehead {
      display: flex;
      h5 {
        margin-left: 10px;
      }
      .category {
        span {
          margin-left: 80px;
        }
      }
    }
    ul {
      li {
        width: 45vw;
        height: 240px;
        margin-right: 10px;
        .Thetitle {
          padding: 9px 5px 0px 5px;
          .Thetitle-top {
            p {
              width: 140px;
            }
          }
        }
      }
    }
  }
  .Live1:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }
  .Figuremove {
    width: 247px;
    height: 151px;
    // background: #409EFF;
    border-radius: 6px 6px 0px 0px;
    img {
      // position:absolute;
      width: 100%;
      height: 100%;
    }
    video {
      width: 100%;
      height: 100%;
    }
  }
  .Thetitle-center {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    .Thetitle-jg {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ff1616;
    }
    .xinx {
      width: 12px;
      height: 11px;
      color: #999999;
      margin-right: 5px;
    }
  }
  .Thetitle-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 11px;
    border-top: 1px solid #f6f6f6;
    padding: 10px 0;
    .el-button--default {
      padding: 0px;
      text-align: center;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      width: 67px;
      height: 23px;
      background: #4ccaff;
      border-radius: 4px;
    }
    .el-button:active {
      border-color: #4ccaff;
    }
  }
  .Photoname {
    display: flex;
    img {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      width: 110px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
  }
  .box {
    width: 100vw;
    margin: 0 auto;
  }
  .head {
    height: 250px;
    .information {
      width: 100vw;
      display: flex;
      .imgslsxx {
        width: 235px;
        height: 202px;
        margin-left: 0px;
        margin-right: 10px;
        .imgls {
          height: 160px;
          width: 120px;
        }
      }
    }
  }
  .lsinformation {
    display: flex;
    text-align: left;
    flex-direction: column;
    h5 {
      font-size: 18px;
    }
    .Thetitle {
      span {
        font-size: 14px;
      }
    }
    .introduce {
      display: block;
      width: 60vw;
      flex-wrap: wrap;
      margin-top: 5px;
      font-size: 12px;
    }
    .certificate {
      margin-top: 10px;
      span {
        font-size: 12px;
      }
    }
  }
  .box-keche {
    text-align: left;
    .Thehead {
      margin-top: 35px;
      display: flex;
      h5 {
        margin-left: 10px;
      }
      .category {
        span {
          margin-left: 80px;
        }
      }
    }
  }
  .sssssda ::v-deep .el-input--suffix .el-input__inner {
    width: 150px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 16px;
  }
  .sssssda
    ::v-deep
    .el-input--suffix
    .el-input__suffix
    .el-input__suffix-inner
    .el-select__caret {
    line-height: 32px;
  }
  .Course1 {
    .Live1 {
      width: 95vw;
      margin-left: 10px;
      .thevideo {
        padding: 10px 20px;
        // .th4 {
        //   overflow-x: hidden;
        //   text-overflow: ellipsis;
        //   white-space: nowrap;
        //   font-size: 15px;
        //   width: 44vw;
        //   text-align: left;
        // }
        .wb {
          width: 50vw;
        }
        .jejq {
          // margin-top: 10px;
          display: flex;
          justify-content: space-between;
          .je {
            width: 66px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ff1616;
          }
          div {
            display: flex;
            img {
              width: 12px;
              height: 12px;
              line-height: 12px;
              margin-right: 8px;
              padding-top: 2px;
            }
            .dzs {
              margin-left: 5px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
            }
          }
        }
        .collection {
          margin-top: 13px;
          display: flex;
          justify-content: space-between;
          .dzs {
            white-space: nowrap;
            height: 13px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
          }
          .Buynow {
            white-space: nowrap;
            // display: flex;
            text-align: center;
            width: 67px;
            height: 23px;
            background: #4ccaff;
            border-radius: 4px;
            border: 1px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
    .Live1:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
    }
  }
  .Course {
    margin-left: 10px;
    .Live1 {
      margin-right: 5px;
      width: 45vw;
      height: 299px;
      margin-bottom: 10px;
      .thevideo {
        display: flex;
        flex-direction: column;
        padding: 5px 5px;
        .th4 {
          width: 44vw;
        }
        .wb {
          width: 40vw;
        }
        .jejq {
          margin-top: 10px;
          display: flex;
          .je {
            width: 40px;
          }
          div {
            display: flex;
            .dzs {
              width: 90px;
              margin-left: 5px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
            }
          }
        }
      }
    }
  }
  .ceisj {
    text-align: center;
    margin-bottom: 54px;
  }
  .videceosa {
    width: 45vw;
    height: 139px;
    border-radius: 6px 6px 0px 0px;
  }
  .el-pagination {
    ::v-deep span {
      padding: 0 10px;
    }
  }
  img {
    object-fit: cover;
  }
  .buttom1 {
    margin-top: 27px;
    .Thehead {
      display: flex;
      h5 {
        margin-left: 10px;
      }
      .category {
        span {
          margin-left: 20px;
        }
      }
    }
    .Course2 {
      display: flex;
      width: 100vw;
      justify-content: left;
      flex-wrap: wrap;
      .Live1 {
        display: flex;
        width: 95vw;
        height: 110px;
        background: #ffffff;
        border: 1px solid #f6f6f6;
        border-radius: 6px;
        margin-bottom: 17px;
        transition: all 0.2s;
        margin-left: 10px;
        .videois {
          width: 200.6px;
          height: 87.6px;
          padding: 12px 6px 10px 10px;
          border-radius: 6px 6px 0px 0px;
          // object-fit: contain;
        }
        .thevideo {
          width: 100%;
          .thename {
            font-size: 15px;
            width: 40vw;
          }
          .wb {
            display: block !important;
            margin-top: 0px !important;
            text-align: left;
            cursor: pointer;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 2; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
            font-size: 12px;
            line-height: 22px;
          }

          .collection {
            // padding-top: 6px;
            // margin-top: 5px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 2px solid #f6f6f6;
            .jejq {
              margin-right: 5px;
              display: flex;
              justify-content: space-between;
              .je {
                // width: 66px;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #ff1616;
              }
              div {
                display: flex;
                align-items: center;
                img {
                  width: 12px;
                  height: 12px;
                  line-height: 12px;
                  margin-right: 8px;
                  padding-top: 2px;
                }
                .dzs {
                  font-size: 12px;
                  margin-left: 5px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #999999;
                }
              }
            }
            .dzs {
              cursor: pointer;
              white-space: nowrap;
              // height: 13px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999;
            }
            .Buynow {
              cursor: pointer;
              white-space: nowrap;
              // display: flex;
              text-align: center;
              width: 67px;
              height: 23px;
              background: #4ccaff;
              border-radius: 4px;
              border: 1px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
            }
            .Buynow:hover {
              background: #4ccaffc9;
            }
          }
        }
      }
      .Live1:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
      }
    }
    .el-pagination {
      margin-top: 60px;
      margin-bottom: 30px;
    }
  }
}
</style>
